{
  "infra.action.addDomain": "Add custom domain",
  "infra.action.connectDomain": "Connect a domain",
  "infra.action.deploy": "Deploy",
  "infra.action.deployGithub": "Deploy from GitHub",
  "infra.action.deployLatest": "Deploy latest",
  "infra.action.recheck": "Recheck status",
  "infra.action.removeDomain": "Remove domain",
  "infra.action.removeImport": "Remove import",
  "infra.action.removeService": "Remove service",
  "infra.action.rollback": "Roll back",
  "infra.api.apiRef": "API reference",
  "infra.api.cliDesc": "Scaffold, run, and ship projects straight from your terminal — auth is shared with this session.",
  "infra.api.connectHead": "CONNECT",
  "infra.api.docs": "Documentation",
  "infra.api.docsLink": "Docs ↗",
  "infra.api.intro": "The managed Symbols platform API. Every project, workspace, build, and domain in this workspace is created and served through it — there is no server to run. Reach it three ways:",
  "infra.api.mcpDesc": "Model Context Protocol server — lets AI agents (Claude, Cursor) read framework rules and generate/audit components against this API.",
  "infra.api.resourcesHead": "RESOURCES",
  "infra.api.sdkDesc": "Typed client for every endpoint — sdk.execute(entity, op, args) or the flat methods used across this app.",
  "infra.api.test": "Test connection",
  "infra.api.unreachable": "unreachable",
  "infra.banner.demoLead": "Demo topology — deploy your first real service to replace it.",
  "infra.banner.emptyLead": "No services deployed yet — deploy your first one.",
  "infra.confirm.deployMessage": "A new build starts from the latest commit. When it succeeds, it replaces the running version.",
  "infra.confirm.deployTitle": "Deploy “{name}”?",
  "infra.confirm.removeDomainMessage": "The project stops serving on this hostname. You can connect the domain again later.",
  "infra.confirm.removeDomainTitle": "Remove the domain “{host}”?",
  "infra.confirm.removeImportMessage": "The import leaves this workspace. Its build and deployment history stays, and a deployed service keeps running.",
  "infra.confirm.removeImportTitle": "Remove the import “{name}”?",
  "infra.confirm.removeServiceMessage": "The service and its connections are removed from the demo.",
  "infra.confirm.removeServiceTitle": "Remove the service “{name}”?",
  "infra.confirm.removeVarMessage": "The next build runs without it. Until then, the running service keeps the current value.",
  "infra.confirm.removeVarTitle": "Remove the variable {key}?",
  "infra.confirm.rollbackMessage": "The service runs the build of this deployment again. A new deployment is added to the history.",
  "infra.confirm.rollbackTitle": "Roll back “{name}” to {version}?",
  "infra.contextMenu.fitView": "Fit to view",
  "infra.contextMenu.newAria": "New service",
  "infra.contextMenu.palette": "Command palette",
  "infra.contextMenu.resetView": "Reset view",
  "infra.contextMenu.status": "System status",
  "infra.copy.baseUrl": "Copy base URL",
  "infra.copy.installCmd": "Copy install command",
  "infra.copy.workspaceId": "Copy workspace ID",
  "infra.count.replicaMany": "{count} replicas",
  "infra.count.replicaOne": "{count} replica",
  "infra.count.serviceMany": "{count} services",
  "infra.count.serviceOne": "{count} service",
  "infra.create.cronHint": "Scheduled job.",
  "infra.create.domainHint": "Connect a custom domain.",
  "infra.create.image": "Docker Image",
  "infra.create.imageHint": "Deploy a container image.",
  "infra.create.island": "Create service",
  "infra.create.mongoHint": "Managed Mongo database.",
  "infra.create.mysqlHint": "Managed MySQL database.",
  "infra.create.postgresHint": "Managed Postgres database.",
  "infra.create.redisHint": "In-memory data store.",
  "infra.create.repo": "GitHub Repo",
  "infra.create.repoHint": "Deploy from a repository.",
  "infra.create.volumeHint": "Persistent storage.",
  "infra.create.workerHint": "Background worker.",
  "infra.deploy.buildFailedShort": "Build failed.",
  "infra.deploy.buildTimedOut": "The build timed out.",
  "infra.deploy.empty": "No deployments yet.",
  "infra.deploy.liveTag": "live",
  "infra.deploy.rowFallback": "Deployment",
  "infra.dns.addRecords": "Add these records at your DNS provider:",
  "infra.dns.checking": "Checking your domain…",
  "infra.dns.configured": "This hostname is already configured on the project — connecting refreshes provisioning.",
  "infra.dns.copyName": "Copy Name",
  "infra.dns.copyType": "Copy Type",
  "infra.dns.copyValue": "Copy Value",
  "infra.dns.head": "DNS records to set",
  "infra.dns.name": "Name",
  "infra.dns.note": "Root/apex domains use the A records shown (or ALIAS/ANAME where supported). TLS is issued automatically once the records resolve.",
  "infra.dns.redirect": "Redirect: {value}",
  "infra.dns.redirectPair": "Redirect: {from} → {to}",
  "infra.dns.routingMode": "Routing mode: {mode}",
  "infra.dns.runCheck": "Run “Check DNS” to get the exact records for this hostname.",
  "infra.dns.type": "Type",
  "infra.dns.value": "Value",
  "infra.domain.alreadyConfigured": "Already configured on this project",
  "infra.domain.deployFirstBody": "Custom domains attach to real projects. Deploy from GitHub first, then return here to check DNS and connect the hostname.",
  "infra.domain.deployFirstTitle": "Deploy a project first",
  "infra.domain.enterHost": "Enter a hostname first.",
  "infra.domain.envLine": "Environment: {env}",
  "infra.domain.linkCaption": "Connect a domain you already own — check DNS, add the records, and the edge verifies + issues TLS.",
  "infra.domain.linkTitle": "Link existing domain",
  "infra.domain.newCaption": "Search for and register a brand-new domain through Symbols.",
  "infra.domain.newTitle": "New domain",
  "infra.domain.noProjects": "No projects in this workspace yet",
  "infra.domain.notAvailable": "Custom domains are not available on this server.",
  "infra.domain.phaseCheck": "Check DNS",
  "infra.domain.phaseChecking": "Checking…",
  "infra.domain.phaseConnect": "Connect domain",
  "infra.domain.phaseConnecting": "Connecting…",
  "infra.domain.phaseDone": "Done",
  "infra.domain.pickProject": "Pick a project first.",
  "infra.domain.projectLine": "Project: {name}",
  "infra.domain.projectNone": "none",
  "infra.domain.routingLine": "Routing: {mode}",
  "infra.domain.soonBody": "Searching and registering domains directly through Symbols is on the way. Until then, register with any provider and link it here — DNS verification and TLS are already fully automated.",
  "infra.domain.soonTitle": "Registration is coming soon",
  "infra.domain.stateLine": "State: {state}",
  "infra.domain.stateReady": "State: ready to connect",
  "infra.domain.statusHead": "Connection status",
  "infra.domain.subChoose": "Connect a custom domain to a project in this workspace.",
  "infra.domain.subLink": "Point a domain you own at a project — the edge and TLS are provisioned for you.",
  "infra.domain.subNew": "Find and register a brand-new domain through Symbols.",
  "infra.domain.switchToLink": "Link an existing domain instead",
  "infra.domain.title": "Add a domain",
  "infra.domain.untitled": "(untitled)",
  "infra.domain.warningFallback": "Domain warning",
  "infra.domain.warnings": "Warnings",
  "infra.domainError.alreadyClaimed": "This hostname is already connected to another project.",
  "infra.domainError.invalidDomain": "That does not look like a valid hostname.",
  "infra.domainError.invalidMap": "The server rejected the domain payload.",
  "infra.domainError.network": "Could not reach the server — check your connection and try again.",
  "infra.domainError.provisioningFailed": "Cloudflare provisioning failed — try again in a moment.",
  "infra.domainError.provisioningUnavailable": "Edge provisioning is not configured on this server yet — the domain was not saved.",
  "infra.domainHint.active": "Connected. Traffic on this domain now routes to your project.",
  "infra.domainHint.failed": "Provisioning failed — recheck, or remove and try again.",
  "infra.domainHint.needsDns": "Add the records below at your DNS provider — we recheck automatically.",
  "infra.domainHint.orphaned": "The edge lost this hostname — remove and connect it again.",
  "infra.domainHint.pendingSsl": "Hostname verified — issuing the TLS certificate.",
  "infra.domainHint.pendingValidation": "Records found — the edge is verifying your hostname.",
  "infra.domainState.active": "Active",
  "infra.domainState.failed": "Failed",
  "infra.domainState.needsDns": "Waiting for DNS",
  "infra.domainState.orphaned": "Orphaned",
  "infra.domainState.pendingSsl": "Issuing certificate",
  "infra.domainState.pendingValidation": "Verifying hostname",
  "infra.env.current": "current",
  "infra.env.switchTo": "switch to",
  "infra.error.deploy": "Couldn't start the deploy",
  "infra.error.forbidden": "You don't have permission to do this. Ask a workspace owner or admin.",
  "infra.error.removeDomain": "Couldn't remove the domain",
  "infra.error.removeImport": "Couldn't remove the import",
  "infra.error.rollback": "Couldn't roll back",
  "infra.error.saveImport": "Couldn't save the import",
  "infra.field.domain": "Domain",
  "infra.field.environment": "Environment",
  "infra.field.private": "Private",
  "infra.field.project": "Project",
  "infra.field.publicUrl": "Public URL",
  "infra.field.region": "Region",
  "infra.field.replicas": "Replicas",
  "infra.field.source": "Source",
  "infra.field.verification": "Verification",
  "infra.filter.all": "All services",
  "infra.filter.apps": "Apps & workers",
  "infra.filter.databases": "Databases",
  "infra.filter.networking": "Networking",
  "infra.filter.storage": "Storage",
  "infra.import.autoDetect": "auto-detect",
  "infra.import.branch": "Branch",
  "infra.import.builder": "Builder",
  "infra.import.head": "IMPORT SETTINGS",
  "infra.import.root": "Service root",
  "infra.import.save": "Save import settings",
  "infra.logs.buildFailedHead": "LAST BUILD FAILED",
  "infra.logs.external": "Open build logs ↗",
  "infra.logs.load": "Load build logs",
  "infra.logs.loading": "Loading build logs…",
  "infra.logs.noBuildsYet": "No builds yet.",
  "infra.logs.reload": "Reload build logs",
  "infra.logs.simulated": "Runtime tail is simulated — log streaming needs the Cloud Logging pipe.",
  "infra.logs.unavailable": "No build logs available yet.",
  "infra.metric.latency": "{count} ms",
  "infra.metric.live": "live",
  "infra.metrics.memory": "MEMORY",
  "infra.metrics.noteLive": "Simulated values — the live metrics collector is not built yet.",
  "infra.metrics.noteMock": "Last 1h average · mocked",
  "infra.node.demo": "DEMO",
  "infra.page.canvas": "Infra",
  "infra.palette.connectDomain": "Connect custom domain",
  "infra.palette.create": "Create {name}",
  "infra.palette.createHint": "New service",
  "infra.palette.deployGithubHint": "Connect · import · build",
  "infra.palette.goto": "Go to {name}",
  "infra.palette.placeholder": "Search actions, services, environments…",
  "infra.palette.switchEnv": "Switch to {name}",
  "infra.repo.alreadyImported": "{name} is already imported.",
  "infra.repo.deploys": "deploys {branch}",
  "infra.repo.importingAny": "Importing the repository — the first build starts right after.",
  "infra.repo.importingLine": "Importing {name} — the first build starts right after.",
  "infra.repo.install": "Install the GitHub App",
  "infra.repo.installBody": "Install the Symbols build app for this workspace and grant it the repositories you want to deploy. You land back here when it finishes.",
  "infra.repo.noInstallUrl": "This server has no GitHub App install URL configured yet — ask an admin to set the build app slug, then recheck.",
  "infra.repo.noMatch": "No repositories match that search.",
  "infra.repo.noRepos": "The installation has no repositories — grant some on GitHub, then recheck.",
  "infra.repo.noWorkspace": "No active workspace resolved yet.",
  "infra.repo.notConnected": "GitHub is not connected yet",
  "infra.repo.private": "private",
  "infra.repo.recheck": "I installed it — recheck",
  "infra.repo.searchAria": "Search repositories",
  "infra.repo.searchPlaceholder": "Search repositories…",
  "infra.repo.stepConnect": "Install the Symbols build app on the repos you want to deploy.",
  "infra.repo.stepError": "Something went wrong talking to the build service.",
  "infra.repo.stepImporting": "Importing the repository…",
  "infra.repo.stepLoading": "Checking your GitHub connection…",
  "infra.repo.stepPick": "Pick a repository — it builds with Cloud Native Buildpacks and deploys to a managed HTTPS URL.",
  "infra.repo.talking": "Talking to the build service…",
  "infra.repo.unknownError": "Unknown error.",
  "infra.role.readOnly": "Contributors and guests can't change the infrastructure. Ask an owner, admin or member.",
  "infra.scale.hintApplied": "Applied to the latest deployment.",
  "infra.scale.hintPending": "Scaling applies after the first deployment.",
  "infra.scale.max": "Max instances",
  "infra.scale.min": "Min instances",
  "infra.sidebar.activity": "Activity",
  "infra.sidebar.activityEmpty": "No live activity yet — deploy something.",
  "infra.sidebar.deployments": "Deployments",
  "infra.sidebar.environment": "ENVIRONMENT",
  "infra.sidebar.project": "PROJECT",
  "infra.sidebar.services": "SERVICES",
  "infra.sidebar.status": "Status",
  "infra.sidebar.templates": "Templates",
  "infra.status.active": "Active",
  "infra.status.building": "Building",
  "infra.status.crashed": "Crashed",
  "infra.status.demoTag": "demo",
  "infra.status.deploying": "Deploying",
  "infra.status.liveTag": "live",
  "infra.status.operational": "{count} operational",
  "infra.status.overallDeploying": "{count} deploying",
  "infra.status.overallDownMany": "{count} services down",
  "infra.status.overallDownOne": "{count} service down",
  "infra.status.overallOk": "All systems operational",
  "infra.status.pageTitle": "System status",
  "infra.status.pending": "Pending",
  "infra.status.removed": "Removed",
  "infra.status.sleeping": "Sleeping",
  "infra.status.unknown": "Unknown",
  "infra.tab.deployments": "Deployments",
  "infra.tab.logs": "Logs",
  "infra.tab.metrics": "Metrics",
  "infra.tab.networking": "Networking",
  "infra.tab.settings": "Settings",
  "infra.tab.variables": "Variables",
  "infra.tls.issued": "issued",
  "infra.tls.issuing": "issuing",
  "infra.tls.pending": "pending",
  "infra.type.api": "Managed API",
  "infra.type.cron": "Cron Job",
  "infra.type.domain": "Domain",
  "infra.type.fallback": "Service",
  "infra.type.image": "Image",
  "infra.type.loadbalancer": "Load Balancer",
  "infra.type.volume": "Volume",
  "infra.type.web": "Web Service",
  "infra.type.worker": "Worker",
  "infra.vars.empty": "No variables set.",
  "infra.vars.liveNote": "Changes PATCH the import — new values apply on the next build.",
  "infra.vars.nameAria": "Variable name",
  "infra.vars.namePlaceholder": "KEY",
  "infra.vars.remove": "Remove variable",
  "infra.vars.valueAria": "Variable value",
  "infra.vars.valuePlaceholder": "value"
}
